import { createFileRoute } from '@tanstack/react-router';

import { AssemblySettingsPage } from '@/areas/settings/bom-components/OrganizationSettings/AssemblySettingsPage';
import { canViewDesignSettings } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/settings/_menu/organization/assembly-settings')({
    staticData: {
        access: { permissions: canViewDesignSettings },
        chrome: 'home',
    } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    return <AssemblySettingsPage />;
}
